import React from "react"

export default function Home() {
  return <div style={{ align: `center`, color: `purple`, fontSize: `72px` }}>You ask who is awesome?<br/>Well, Jim is of course!</div>
}
